import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import api from '../../services/api';
import { getImageUrl } from '../../utils/imageUrl';
import './Footer.css';

const Footer = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await api.get('/settings');
      setSettings(response.data.data);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            {settings?.frontendMedia?.logoWhite ? (
              <img
                src={getImageUrl(settings.frontendMedia.logoWhite)}
                alt="شركة زاد الماسية"
                className="footer-logo"
              />
            ) : (
              <>
                <h3>شركة زاد الماسية</h3>
                <p>للصيانة والتشغيل</p>
              </>
            )}
            <p className="footer-tagline">هوية سعودية ... بمعايير عالمية</p>
            {settings?.socialMedia && Object.values(settings.socialMedia).some(link => link) && (
              <div className="footer-social">
                {settings.socialMedia.facebook && (
                  <a href={settings.socialMedia.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                )}
                {settings.socialMedia.twitter && (
                  <a href={settings.socialMedia.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                    <i className="fab fa-twitter"></i>
                  </a>
                )}
                {settings.socialMedia.instagram && (
                  <a href={settings.socialMedia.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                    <i className="fab fa-instagram"></i>
                  </a>
                )}
                {settings.socialMedia.linkedin && (
                  <a href={settings.socialMedia.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                )}
                {settings.socialMedia.youtube && (
                  <a href={settings.socialMedia.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                    <i className="fab fa-youtube"></i>
                  </a>
                )}
              </div>
            )}
          </div>

          <div className="footer-section">
            <h4>خدماتنا</h4>
            <ul>
              <li><a href="/services">الصيانة العامة</a></li>
              <li><a href="/services">خدمات النظافة</a></li>
              <li><a href="/services">إدارة الأصول</a></li>
              <li><a href="/services">التشطيبات</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>روابط سريعة</h4>
            <ul>
              <li><a href="/about">من نحن</a></li>
              <li><a href="/projects">مشاريعنا</a></li>
              <li><a href="/blog">المدونة</a></li>
              <li><a href="/contact">تواصل معنا</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>تواصل معنا</h4>
            <p>📍 KSA, Makkah, Time Tower</p>
            <p>📧 info@zd.sa</p>
            <p>📱 <span dir="ltr">+966 1252 99111</span></p>
            <p>💬 <span dir="ltr">+966 56 353 5568</span></p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 شركة زاد الماسية. جميع الحقوق محفوظة</p>
        </div>
      </div>
      <div className="developer-bar">
        <a href="https://leadersdeals.com/" target="_blank" rel="noopener noreferrer">
          <img src="/images/leaders-deals-logo.png" alt="Leaders Deals Co" className="developer-logo" />
          <span>Developed by Leaders Deals Co</span>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
